import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { motion, useAnimation } from "framer-motion"
import DonateTabs from "../DonateTabs/DonateTabs"
import PaymentIcons from "../PaymentIcons"

const DonateForm = ({ slice, donateform, page }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.4,
  })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])
  
  return (
    <motion.div
      ref={ref}
      animate={controls}
      transition={
        {
          type: "tween",
          ease: "easeIn",
          delay: 0.25,
        }
      }
      initial="hidden"
      // className={`${inView ? "reveal" : ""}`}
      // className={inView ? "fade-in" : ""}
      // className="section container callouts"
      variants={{
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
          },
        },
        hidden: {
          opacity: 0,
          y: 50,
        },
      }}
    >
      <div className="section donation-slice">
        <div className="container">
          <header class="section-title donation-slice__grid">
            <div className="donation-slice__grid-item padding-1">
              <h3 className="donation-slice-title">{slice.primary.title.text}</h3>
            </div>
            <DonateTabs className="donation-grid__item" />

            <PaymentIcons />
    
          </header>
        </div>
      </div>
    </motion.div>
  )
}

export default DonateForm
